import Navbar from './layout/Navbar';
import Footer from './layout/Footer';
import Footer2 from './layout/Footer2'
import 'bootstrap/dist/css/bootstrap.min.css';
import HomePage from './pages/HomePage';
import CalendarUsPage from './pages/CalendarPage'
import LoginPage from './pages/LoginPage'
import AboutPage from './pages/AboutPage'
import AttendingPage from './pages/AttendingPage';
import ContactUs from './pages/ContactPage'
import EventPage from './pages/EventPage';
import 'bootstrap/dist/css/bootstrap.min.css';
import NotFoundPage from './pages/NotFoundPage';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import OurGroups from './pages/OurGroupsPage';
import EventMapPage from './pages/EventMapPage';
import { useState } from 'react';

// test

function App() {

  const [disable,setDisable] = useState(null)
  
  

  return (
    <div style={{display: 'flex', flexDirection: 'column', minHeight: '100dvh'}}>
      <Router>
        <Navbar />

        <div style={{flex: 1, display: 'flex', flexDirection: 'column'}}>
          <Routes>

            <Route exact path="/" element={<HomePage/>} />
            <Route exact path="/calendar" element={<CalendarUsPage/>}/>
            {/* <Route exact path="/login" element={<LoginPage/>}/> */}
            <Route exact path="/about" element={<AboutPage/>}/>

            <Route exact path="/events" element={<AttendingPage/>}/>

            <Route exact path="/events/map" element={<EventMapPage/>}/>

            <Route exact path="/contact-us" element={<ContactUs/>}/>
            <Route exact path="/groups" element={<OurGroups/>}/>
            {/* <Route exact path="/events" element={<EventPage/>}/> */}

            {/* 404 Not Found Page */}
            <Route path="*" element={<NotFoundPage />} />

          </Routes>
        </div>

        {/* <Footer2 /> */}
        <Footer />

      </Router>


    </div>
  );
}

export default App;
